(function () {
    'use strict';

    if (typeof window === 'undefined') {
        strings(
            module.exports,
            require('lodash')
        );
    } else {
        strings(RivalIQ.strings, window._);
    }

    function strings(strings, _) {

        // NOTE these strings are mechanically generated from the Insights API
        const facebookInsightsPostDisplayStrings = {
            'post_story_adds_unique': {
                'title': 'Lifetime Talking About This (Post)',
                'description': 'Lifetime: The number of unique people who created a story by interacting with your Page post. (Unique Users)'
            },
            'post_story_adds': {
                'title': 'Lifetime Post Stories',
                'description': 'Lifetime: The number of stories generated about your Page post. (Total Count)'
            },
            'post_story_adds_by_action_type_unique': {
                'title': 'Lifetime Talking About This (Post) by action type',
                'description': 'Lifetime: The number of unique people who created a story about your Page post by interacting with it. (Unique Users)'
            },
            'post_story_adds_by_action_type': {
                'title': 'Lifetime Post Stories by action type',
                'description': 'Lifetime: The number of stories created about your Page post, by action type. (Total Count)'
            },
            'post_impressions_unique': {
                'title': 'Lifetime Post Total Reach',
                'description': 'Lifetime: The total number of people your Page post was served to. (Unique Users)'
            },
            'post_impressions': {
                'title': 'Lifetime Post Total Impressions',
                'description': 'Lifetime: The number of impressions of your Page post. (Total Count)'
            },
            'post_impressions_paid_unique': {
                'title': 'Lifetime Post Paid Reach',
                'description': 'Lifetime: The number of people your advertised Page post was served to. (Unique Users)'
            },
            'post_impressions_paid': {
                'title': 'Lifetime Post Paid Impressions',
                'description': 'Lifetime: The number of impressions of your Page post in an Ad or Sponsored Story. (Total Count)'
            },
            'post_impressions_organic_unique': {
                'title': 'Lifetime Post organic reach',
                'description': `Lifetime: The number of people who saw your Page post in news feed or ticker, or on your Page's timeline. (Unique Users)`
            },
            'post_impressions_organic': {
                'title': 'Lifetime Post Organic Impressions',
                'description': `Lifetime: The number of impressions of your post in News Feed or ticker or on your Page's Timeline. (Total Count)`
            },
            'post_impressions_viral_unique': {
                'title': 'Lifetime Post viral reach',
                'description': 'Lifetime: The number of people who saw your Page post in a story from a friend. (Unique Users)'
            },
            'post_impressions_viral': {
                'title': 'Lifetime Post Viral Impressions',
                'description': 'Lifetime: The number of impressions of your Page post in a story generated by a friend. (Total Count)'
            },
            'post_impressions_by_story_type_unique': {
                'title': 'Lifetime Post viral reach by story type',
                'description': 'Lifetime: The number of people who saw your Page post in a story from a friend, by story type. (Unique Users)'
            },
            'post_impressions_by_story_type': {
                'title': 'Lifetime Post Viral Impressions by story type',
                'description': 'Lifetime: The number of times people saw this post via stories published by their friends. (Total Count)'
            },
            'post_impressions_fan_unique': {
                'title': 'Lifetime Post reach by people who like your Page',
                'description': `Lifetime: The number of people who saw your Page post because they've liked your Page (Unique Users)`
            },
            'post_impressions_fan': {
                'title': 'Lifetime Post Impressions by people who have liked your Page',
                'description': 'Lifetime: The number of impressions of your Page post to people who have liked your Page. (Total Count)'
            },
            'post_impressions_fan_paid_unique': {
                'title': 'Lifetime Paid reach of a post by people who like your Page',
                'description': 'Lifetime: The number of people who like your Page and who saw your Page post in an ad or sponsored story. (Unique Users)'
            },
            'post_impressions_fan_paid': {
                'title': 'Lifetime Post Paid Impressions by people who have liked your Page',
                'description': 'Lifetime: The number of paid impressions of your Page post to people who have liked your Page. (Total Count)'
            },
            'post_impressions_by_paid_non_paid_unique': {
                'title': 'Lifetime Post impressions by paid and non-paid',
                'description': 'Lifetime: The number of impressions of your Page post broken down by paid and non-paid. (Unique Users)'
            },
            'post_impressions_by_paid_non_paid': {
                'title': 'Lifetime Post impressions by paid and non-paid',
                'description': 'Lifetime: The number of impressions of your Page post broken down by paid and non-paid. (Total Count)'
            },
            'post_video_length': {
                'title': 'Lifetime Video length',
                'description': 'Lifetime: Length of a video post (Total Count)'
            },
            'post_video_retention_graph': {
                'title': 'Lifetime Percentage of viewers at each interval (video post)',
                'description': 'Lifetime: Views of your video at each moment as a percentage of all views, including views shorter than 3 seconds. (video post) (Total Count)'
            },
            'post_video_retention_graph_autoplayed': {
                'title': 'Lifetime Percentage of auto-played viewers at each interval (video post)',
                'description': 'Lifetime: Auto-played views of your video at each moment as a percentage of all views, including views shorter than 3 seconds. (video post) (Total Count)'
            },
            'post_video_retention_graph_clicked_to_play': {
                'title': 'Lifetime Percentage of viewers clicked-to-play at each interval (video post)',
                'description': 'Lifetime: Clicked-to-play views of your video at each moment as a percentage of all views, including views shorter than 3 seconds. (video post) (Total Count)'
            },
            'post_video_avg_time_watched': {
                'title': 'Lifetime Average time video viewed',
                'description': 'Lifetime: Average time video viewed (Total Count)'
            },
            'post_video_views': {
                'title': 'Lifetime Total Video Views',
                'description': 'Lifetime: Total number of times your video was viewed for more than 3 seconds. (Total Count)'
            },
            'post_video_views_unique': {
                'title': 'Lifetime Unique Video Views',
                'description': 'Lifetime: Number of unique people who viewed your video for more than 3 seconds. (Unique Users)'
            },
            'post_video_views_autoplayed': {
                'title': 'Lifetime Auto-Played Video Views',
                'description': 'Lifetime: Number of times your video started automatically playing and people viewed it for more than 3 seconds. (Total Count)'
            },
            'post_video_views_clicked_to_play': {
                'title': 'Lifetime Clicked-to-Play Video Views',
                'description': 'Lifetime: Number of times people clicked to play your video and viewed it more than 3 seconds. (Total Count)'
            },
            'post_video_views_organic': {
                'title': 'Lifetime Organic Video Views',
                'description': 'Lifetime: Number of times your video was viewed for more than 3 seconds without any paid promotion. (Total Count)'
            },
            'post_video_views_organic_unique': {
                'title': 'Lifetime Organic Video Views',
                'description': 'Lifetime: Number of times your video was viewed for more than 3 seconds without any paid promotion. (Unique Users)'
            },
            'post_video_complete_views_organic': {
                'title': 'Lifetime Organic views to 95%',
                'description': 'Lifetime: Number of times your video was viewed to 95% of its length without any paid promotion. (Total Count)'
            },
            'post_video_complete_views_organic_unique': {
                'title': 'Lifetime Organic views to 95%',
                'description': 'Lifetime: Number of times your video was viewed to 95% of its length without any paid promotion. (Unique Users)'
            },
            'post_video_views_paid': {
                'title': 'Lifetime Paid Video Views',
                'description': 'Lifetime: Number of times your video was viewed more than 3 seconds after paid promotion. (Total Count)'
            },
            'post_video_views_paid_unique': {
                'title': 'Lifetime Paid Video Views',
                'description': 'Lifetime: Number of times your video was viewed more than 3 seconds after paid promotion. (Unique Users)'
            },
            'post_video_complete_views_paid': {
                'title': 'Lifetime Paid views to 95%',
                'description': 'Lifetime: Number of times your video was viewed to 95% of its length after paid promotion. (Total Count)'
            },
            'post_video_complete_views_paid_unique': {
                'title': 'Lifetime Paid views to 95%',
                'description': 'Lifetime: Number of times your video was viewed to 95% of its length after paid promotion. (Unique Users)'
            },
            'post_video_complete_views_30s': {
                'title': 'Lifetime Total 30-Second Views',
                'description': 'Lifetime: Total number of times your video was viewed for 30 seconds or viewed to the end, whichever came first. (Total Count)'
            },
            'post_video_complete_views_30s_unique': {
                'title': 'Lifetime Unique 30-Second Views',
                'description': 'Lifetime: Number of unique people who viewed your video for 30 seconds or to the end, whichever came first. (Unique Users)'
            },
            'post_video_complete_views_30s_autoplayed': {
                'title': 'Lifetime Auto-Played 30-Second Views',
                'description': 'Lifetime: Number of times your video started automatically playing and people viewed it for 30 seconds or to the end, whichever came first. (Total Count)'
            },
            'post_video_complete_views_30s_clicked_to_play': {
                'title': 'Lifetime Clicked-to-Play 30-Second Views',
                'description': 'Lifetime: Number of times people clicked to play your video and viewed it for 30 seconds or to the end, whichever came first. (Total Count)'
            },
            'post_video_complete_views_30s_organic': {
                'title': 'Lifetime Organic 30-Second Views',
                'description': 'Lifetime: Number of times your video was viewed for 30 seconds or viewed to the end, whichever came first, without a paid promotion. (Total Count)'
            },
            'post_video_complete_views_30s_paid': {
                'title': 'Lifetime Paid 30-Second Views',
                'description': 'Lifetime: Number of times your video was viewed for 30 seconds or viewed to the end, whichever came first, after a paid promotion. (Total Count)'
            },
            'post_consumptions_unique': {
                'title': 'Lifetime Post Consumers',
                'description': 'Lifetime: The number of people who clicked anywhere in your post. (Unique Users)'
            },
            'post_consumptions': {
                'title': 'Lifetime Post Consumptions',
                'description': 'Lifetime: The number of clicks anywhere in your post. (Total Count)'
            },
            'post_consumptions_by_type_unique': {
                'title': 'Lifetime Post consumers by type',
                'description': 'Lifetime: The number of people who clicked anywhere in your post, by type. (Unique Users)'
            },
            'post_consumptions_by_type': {
                'title': 'Lifetime Post Consumptions by type',
                'description': 'Lifetime: The number of clicks anywhere in your post, by type. (Total Count)'
            },
            'post_negative_feedback_unique': {
                'title': 'Lifetime Negative feedback',
                'description': 'Lifetime: The number of people who have given negative feedback to your post. (Unique Users)'
            },
            'post_negative_feedback': {
                'title': 'Lifetime Negative Feedback from Users',
                'description': 'Lifetime: The number of times people have given negative feedback to your post. (Total Count)'
            },
            'post_negative_feedback_by_type_unique': {
                'title': 'Lifetime Negative feedback',
                'description': 'Lifetime: The number of people who have given negative feedback to your post, by type. (Unique Users)'
            },
            'post_negative_feedback_by_type': {
                'title': 'Lifetime Negative Feedback from Users by Type',
                'description': 'Lifetime: The number of times people have given negative feedback to your post, by type. (Total Count)'
            },
            'post_engaged_fan': {
                'title': 'Lifetime People who have liked your Page and engaged with your post',
                'description': 'Lifetime: The number of people who have liked your Page and clicked anywhere in your posts. (Unique Users)'
            },
            'post_fan_reach': {
                'title': 'Lifetime Post reach by people who like your Page',
                'description': `Lifetime: The number of people who saw your Page post because they've liked your Page (Unique Users)`
            },
            'post_storytellers': {
                'title': 'Lifetime Talking About This (Post)',
                'description': 'Lifetime: The number of unique people who created a story by interacting with your Page post. (Unique Users)'
            },
            'post_storytellers_by_action_type': {
                'title': 'Lifetime Talking About This (Post) by action type',
                'description': 'Lifetime: The number of unique people who created a story about your Page post by interacting with it. (Unique Users)'
            },
            'post_engaged_users': {
                'title': 'Lifetime Engaged Users',
                'description': 'Lifetime: The number of people who clicked anywhere in your posts. (Unique Users)'
            },
            'post_stories': {
                'title': 'Lifetime Post Stories',
                'description': 'Lifetime: The number of stories generated about your Page post. (Total Count)'
            },
            'post_stories_by_action_type': {
                'title': 'Lifetime Post Stories by action type',
                'description': 'Lifetime: The number of stories created about your Page post, by action type. (Total Count)'
            },
            'post_interests_impressions_unique': {
                'title': 'Lifetime Total Matched Audience Targeting Reach',
                'description': 'Lifetime: The total number of people matched the audience targeting on Page post on News Feed was served. (Total Count)'
            },
            'post_interests_impressions': {
                'title': 'Lifetime Total Matched Audience Targeting Impressions',
                'description': 'Lifetime: The number of matched audience targeting impressions of your Page post on News Feed. (Total Count)'
            },
            'post_interests_consumptions_unique': {
                'title': 'Lifetime Matched Audience Targeting Consumers on Post',
                'description': 'Lifetime: The number of people who matched the audience targeting that clicked anywhere in your post on News Feed. (Unique Users)'
            },
            'post_interests_consumptions': {
                'title': 'Lifetime Matched Audience Targeting Consumptions on Post',
                'description': 'Lifetime: The number of clicks anywhere in your post on News Feed from the user that matched the audience targeting on it. (Total Count)'
            },
            'post_interests_consumptions_by_type_unique': {
                'title': 'Lifetime Post Audicen Targeting matched consumers by type',
                'description': 'Lifetime: The number of people who matched the audience  targeting on post that clicked anywhere in your post on News Feed, by type. (Unique Users)'
            },
            'post_interests_consumptions_by_type': {
                'title': 'Lifetime Matched Audience Targeting Consumptions by type on Post',
                'description': 'Lifetime: The number of clicks anywhere in your post on News Feed from users that matched the audience targeting on the post, by type. (Total Count)'
            },
            'post_interests_action_by_type_unique': {
                'title': 'Lifetime Talking About This (Post) by action type from users that matched the Audience Targeting on the post',
                'description': 'Lifetime: The number of unique people matched the audience targeting on the post on News Feed from who created a story about your Page post by interacting with it. (Unique Users)'
            },
            'post_interests_action_by_type': {
                'title': 'Lifetime Post Stories from users that matched the Audience Targeting on the post by action type',
                'description': 'Lifetime: The number of stories created about your Page post on News Feed, from users that matched the Audience Targeting on the Post by action type. (Total Count)'
            },
            'post_video_views_10s': {
                'title': 'Lifetime Total 10-Second Views',
                'description': 'Lifetime: Total number of times your video was viewed for 10 seconds or viewed to the end, whichever came first. (Total Count)'
            },
            'post_video_views_10s_unique': {
                'title': 'Lifetime Unique 10-Second Views',
                'description': 'Lifetime: Number of unique people who viewed your video for 10 seconds or to the end, whichever came first. (Unique Users)'
            },
            'post_video_views_10s_paid': {
                'title': 'Lifetime Paid 10-Second Views',
                'description': 'Lifetime: Number of times your video was viewed for 10 seconds or viewed to the end, whichever came first, after a paid promotion. (Total Count)'
            },
            'post_video_views_10s_organic': {
                'title': 'Lifetime Organic 10-Second Views',
                'description': 'Lifetime: Number of times your video was viewed for 10 seconds or viewed to the end, whichever came first, without a paid promotion. (Total Count)'
            },
            'post_video_views_10s_clicked_to_play': {
                'title': 'Lifetime Clicked-to-Play 10-Second Views',
                'description': 'Lifetime: Number of times people clicked to play your video and viewed it for 10 seconds or to the end, whichever came first. (Total Count)'
            },
            'post_video_views_10s_autoplayed': {
                'title': 'Lifetime Auto-Played 10-Second Views',
                'description': 'Lifetime: Number of times your video started automatically playing and people viewed it for 10 seconds or to the end, whichever came first. (Total Count)'
            },
            'post_video_views_10s_sound_on': {
                'title': 'Lifetime 10-Second Views with sound on',
                'description': 'Lifetime: Number of times your video sound was turned on and was viewed for 10 seconds or viewed to the end, whichever came first. (Total Count)'
            },
            'post_video_views_sound_on': {
                'title': 'Lifetime Video Views with sound on',
                'description': 'Lifetime: Number of times your video sound was turned on and was viewed for 3 seconds or viewed to the end, whichever came first. (Total Count)'
            },
            'post_video_view_time': {
                'title': 'Lifetime Total Video View Time (in MS)',
                'description': 'Lifetime: Total time (in ms) video has been viewed (Total Count)'
            },
            'post_video_view_time_paid': {
                'title': 'Lifetime Total Paid Video View Time (in MS)',
                'description': 'Lifetime: Total time video (in ms) has been viewed after paid promotion. (Total Count)'
            },
            'post_video_view_time_organic': {
                'title': 'Lifetime Total Organic Video View Time (in MS)',
                'description': `Lifetime: Total time (in ms) video has been viewed in news feed or ticker or on your Page's Timeline. (Total Count)`
            },
            'post_reactions_like_total': {
                'title': 'Daily total like reactions of a post.',
                'description': 'Daily total like reactions of a post.'
            },
            'post_reactions_love_total': {
                'title': 'Daily total love reactions of a post.',
                'description': 'Daily total love reactions of a post.'
            },
            'post_reactions_wow_total': {
                'title': 'Daily total wow reactions of a post.',
                'description': 'Daily total wow reactions of a post.'
            },
            'post_reactions_haha_total': {
                'title': 'Daily total haha reactions of a post.',
                'description': 'Daily total haha reactions of a post.'
            },
            'post_reactions_sorry_total': {
                'title': 'Daily total sorry reactions of a post.',
                'description': 'Daily total sorry reactions of a post.'
            },
            'post_reactions_anger_total': {
                'title': 'Daily total anger reactions of a post.',
                'description': 'Daily total anger reactions of a post.'
            },
            'post_reactions_by_type_total': {
                'title': 'Daily total post reactions by type.',
                'description': 'Daily total post reactions by type.'
            }
        };

        // normalized
        _.each(facebookInsightsPostDisplayStrings, function (value, key) {
            strings[`facebook_insights_${key}_title`] = strings[`facebook_insights_${key}_title`] || value.title;
            strings[`facebook_insights_${key}_description`] = strings[`facebook_insights_${key}_description`] || value.description;
        });
    }
})();
